import {Component, OnInit} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';

import {DataExchangeService} from '../../../../../../surface3d/src/lib/API/Public/data-exchange.service';
import {EditorControlService} from '../../../../../../surface3d/src/lib/API/Public/editor-control.service';

import {ConfirmationDialogComponent} from '../../../Application/ConfirmationDialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatButtonToggleChange} from '@angular/material/button-toggle';
import {ClientInfoService} from '../../../ClientInfo/client-info.service';

@Component({
    selector: 'burncase-image-wizard',
    templateUrl: './image-wizard.component.html',
    styleUrls: ['./image-wizard.component.css']
})
export class ImageWizardComponent implements OnInit {

    public placeLandmarks = true;

    constructor(private router: Router,
                private editorControlService: EditorControlService,
                public dataExchangeService: DataExchangeService,
                private clientInfoService: ClientInfoService,
                private matDialog: MatDialog) {

    }

    ngOnInit() {
    }

    get mode(): string {
        return this.dataExchangeService.image.landmarkMode;
    }

    /**
     * navigates back to home view
     */
    public back() {
        let width = '20%';
        if (this.clientInfoService.isHandset) {
            if (this.clientInfoService.smallScreenSize) {
                width = '75%';
            } else {
                width = '50%';
            }
        }
        if (this.mode === 'image') {
            const dialogRef = this.matDialog.open(ConfirmationDialogComponent,
                {
                    data: {
                        text: 'Abort Landmark Placement?',
                        cancel: true
                    },
                    width: width
                });
            dialogRef.disableClose = true;

            dialogRef.afterClosed().subscribe(confirmed => {
                if (confirmed) {
                    this.closeView();
                }
            });
        } else {
            this.dataExchangeService.image.switchLandmarkMode();
            this.placeLandmarks = true;
        }
    }

    public changeInteractionMode(event: MatButtonToggleChange) {
        this.changeInteractionModeByName(event.source.value);
    }

    public changeInteractionModeByName(name: string) {
        this.editorControlService.ctrl.next(name);
        this.placeLandmarks = name === 'placeLandmarks';
    }

    public untoggleButton(event: MatButtonToggleChange) {
        event.source.checked = false;
    }

    public checkPlacementButton(event: MatButtonToggleChange) {
        this.untoggleButton(event);
        event.source.buttonToggleGroup._buttonToggles.first.checked = true;
    }

    public closeView() {
        this.router.navigate(['/burns']);
        // TODO: check why painting is offset
    }

    public nextView() {
        this.dataExchangeService.image.switchLandmarkMode();
        this.changeInteractionModeByName('placeLandmarks');
    }
}
